module.exports = __webpack_public_path__ + "img/green_120.e747b352.png";